import React from "react";

const capabilities = [
  "Conversational AI that understands nuance and context.",
  "Knowledge graphs that bridge documents, people, and signals.",
  "Full-cycle automation orchestrated across SaaS tools.",
  "Human-in-the-loop controls and audit-friendly telemetry.",
  "Audio/visual media agents tuned for creative storytelling."
];

const styles = {
  leanSection: {
    maxWidth: 1100,
    margin: "32px auto",
    padding: "0 1.5rem",
    textAlign: "center"
  },
  sectionTitle: {
    margin: 0,
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "white"
  },
  capabilityGrid: {
    marginTop: 32,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 20,
    justifyContent: "center"
  },
  capabilityCard: {
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: 18,
    padding: "1.75rem",
    background: "rgba(255,255,255,0.03)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
    minHeight: 180,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center"
  },
  capabilityText: {
    color: "#E3E6EF",
    fontSize: "1rem",
    lineHeight: 1.8,
    margin: 0
  }
};

const CapabilitiesPage = () => (
  <section style={styles.leanSection}>
    <h2 style={styles.sectionTitle}>Capabilities</h2>
    <div style={styles.capabilityGrid}>
      {capabilities.map((item) => (
        <article key={item} style={styles.capabilityCard}>
          <p style={styles.capabilityText}>{item}</p>
        </article>
      ))}
    </div>
  </section>
);

export default CapabilitiesPage;
